module.exports = __webpack_public_path__ + "media/video.854a18b5.mp4";